const NAMES = {
  LOGIN: 'login',
  SIGNUP: 'signUp',
  FORGOT: 'forgot',
  RESET: 'reset',
  APP: 'app',
  APP_INTRO: 'intro',
  APP_NETWORK: 'network',
  APP_NETWORK_NOTIFICATIONS: 'notifications',
  APP_NETWORK_HOME: 'home',
  APP_NETWORK_PEOPLE: 'people',
  APP_NETWORK_PEOPLE_SEARCH: 'search',
  APP_NETWORK_PEOPLE_STATISTICS: 'statistics',
  APP_NETWORK_PEOPLE_MYTAGS: 'my-tags',
  APP_NETWORK_QUESTIONS: 'questions',
  APP_NETWORK_ADMINISTRATION: 'settings',
  APP_NETWORK_ADMINISTRATION_DETAILS: 'details',
  APP_NETWORK_ADMINISTRATION_TAG_MANAGER: 'tag-manager',
  APP_NETWORK_ADMINISTRATION_MEMBERS: 'members'
};

const PATHS = {
  LOGIN: NAMES.LOGIN,
  SIGN_UP: NAMES.SIGNUP,
  FORGOT: NAMES.FORGOT,
  RESET: NAMES.RESET,
  APP: NAMES.APP,
  APP_INTRO: `${NAMES.APP}.${NAMES.APP_INTRO}`,
  APP_NETWORK: `${NAMES.APP}.${NAMES.APP_NETWORK}`,
  APP_NETWORK_NOTIFICATIONS: `${NAMES.APP}.${NAMES.APP_NETWORK}.${
    NAMES.APP_NETWORK_NOTIFICATIONS
  }`,
  APP_NETWORK_HOME: `${NAMES.APP}.${NAMES.APP_NETWORK}.${
    NAMES.APP_NETWORK_HOME
  }`,
  APP_NETWORK_PEOPLE: `${NAMES.APP}.${NAMES.APP_NETWORK}.${
    NAMES.APP_NETWORK_PEOPLE
  }`,
  APP_NETWORK_PEOPLE_SEARCH: `${NAMES.APP}.${NAMES.APP_NETWORK}.${
    NAMES.APP_NETWORK_PEOPLE
  }.${NAMES.APP_NETWORK_PEOPLE_SEARCH}`,
  APP_NETWORK_PEOPLE_STATISTICS: `${NAMES.APP}.${NAMES.APP_NETWORK}.${
    NAMES.APP_NETWORK_PEOPLE
  }.${NAMES.APP_NETWORK_PEOPLE_STATISTICS}`,
  APP_NETWORK_PEOPLE_MYTAGS: `${NAMES.APP}.${NAMES.APP_NETWORK}.${
    NAMES.APP_NETWORK_PEOPLE
  }.${NAMES.APP_NETWORK_PEOPLE_MYTAGS}`,
  APP_NETWORK_QUESTIONS: `${NAMES.APP}.${NAMES.APP_NETWORK}.${
    NAMES.APP_NETWORK_QUESTIONS
  }`,
  APP_NETWORK_ADMINISTRATION: `${NAMES.APP}.${NAMES.APP_NETWORK}.${
    NAMES.APP_NETWORK_ADMINISTRATION
  }`,
  APP_NETWORK_ADMINISTRATION_DETAILS: `${NAMES.APP}.${NAMES.APP_NETWORK}.${
    NAMES.APP_NETWORK_ADMINISTRATION
  }.${NAMES.APP_NETWORK_ADMINISTRATION_DETAILS}`,
  APP_NETWORK_ADMINISTRATION_TAG_MANAGER: `${NAMES.APP}.${NAMES.APP_NETWORK}.${
    NAMES.APP_NETWORK_ADMINISTRATION
  }.${NAMES.APP_NETWORK_ADMINISTRATION_TAG_MANAGER}`,
  APP_NETWORK_ADMINISTRATION_MEMBERS: `${NAMES.APP}.${NAMES.APP_NETWORK}.${
    NAMES.APP_NETWORK_ADMINISTRATION
  }.${NAMES.APP_NETWORK_ADMINISTRATION_MEMBERS}`
};

export { NAMES as ROUTE_NAMES, PATHS as ROUTE_PATHS };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/routes.ts